import React from "react"
import { graphql } from "gatsby"
import { Helmet } from "react-helmet"
import { Layout, MainContainer, AsideContainer } from "../components/layout"
import { RecentStories } from "src/components/recent_stories"
import { LatestPosts } from "src/components/latest_posts"
import { NowReadingAside } from "src/components/asides/now_reading"
import { PreviousReadsAside } from "src/components/asides/previous_reads"
import { SocialAside } from "src/components/asides/social"
import styled from "styled-components"


const IntroSection = styled.section `
  margin: 0rem 0;
  display: block;
`

const IntroTitle = styled.h1 `
  font-weight: 300;
  color: #000;
  /* font-style: italic; */
  line-height: 1.25;
  font-size: 2.5rem;
  margin: 0 0 2.5rem 0;

  @media (min-width: 1024px) {
    font-size: 2.25rem;
    line-height: 1.5;
    text-align: center;
    margin: 0 3rem 2.5rem;
  }

`

const IntroP = styled.p `
  font-size: 1.25rem;
  color: #000;

  & > a {
    color: #C22700;
    text-decoration: none;
    padding-bottom: 0.125rem;
    border-bottom: 1px solid #C22700;
  }
`

export default ({ data }) => (
  <Layout>
    <Helmet>
      <title>Home | {data.site.siteMetadata.title}</title>
    </Helmet>
    <MainContainer>
      <IntroSection>
        <IntroTitle>Stringing words together and hoping for the best
        </IntroTitle>
        <IntroP>
        Hi, I'm Cristina, a writer and bibliophile in Pittsburgh. My work explores our identities and relationships through
disability and immigrant experiences. Welcome!
        </IntroP>
        <IntroP>
        I hold an MFA from the Vermont College of Fine Arts where I immersed myself in all things narrative. My work is
forthcoming from <i>Witness</i> and has appeared in <i>monkeybicycle</i>, the Stillhouse Press anthology <i>In Between Spaces</i>, <i>descant</i>, and elsewhere. My story <i>The Treasure Room</i> was <a href="https://mastersreview.com/2021-summer-short-story-award-shortlist/" target="_blank" rel="noreferrer">shortlisted</a> for the Masters Review Summer Short Story
Award.
        </IntroP>
        <IntroP>
        Now to more important things! I am the proud owner of dozens upon dozens of scarves and wear gloves sized
for children ages 8-14. I will talk about anything literary, cultural, and historical. I have also learned how to thank
people in 14 languages.
        </IntroP>
        <IntroP>
        Here you can find links to my published stories and my thoughts on writing and culture
        </IntroP>
      </IntroSection>
      <LatestPosts />
      <RecentStories />
    </MainContainer>
    <AsideContainer>
      <SocialAside />
      <NowReadingAside />
      <PreviousReadsAside />
    </AsideContainer>
  </Layout>
)

export const query = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`